module.exports = __webpack_public_path__ + "img/hvezda3.cd3b068a.png";